var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconPlans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38805",
    "data-name": "Group 38805",
    transform: "translate(-1273.893 -4983.893)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1273.893 4983.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus",
    "data-name": "Icon feather-plus",
    transform: "translate(1278.077 4988.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47820",
    "data-name": "Path 47820",
    d: "M18,7.5V24.131",
    transform: "translate(-2.185)",
    fill: "none",
    stroke: "#46cf96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47821",
    "data-name": "Path 47821",
    d: "M7.5,18H24.131",
    transform: "translate(0 -2.185)",
    fill: "none",
    stroke: "#46cf96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconPlans);
export default __webpack_public_path__ + "static/media/plus-icon-plans.f11a5d817c31833d5b21f85f8c2568f6.svg";
export { ForwardRef as ReactComponent };